import type { ColumnInput } from '@/types/export';

export const tryDownloadExportedContent = async (
  restBaseUrl: string,
  receiptId: string,
  headers: HeadersInit,
): Promise<Response> => {
  const url = `${restBaseUrl}/exports/${receiptId}`;

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers,
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  });
};

export const showDownloadedContent = (downloadedBlob: Blob, fileName: string): void => {
  const element = document.createElement('a');
  element.href = URL.createObjectURL(downloadedBlob);
  element.download = `${fileName}.xlsx`;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
  URL.revokeObjectURL(element.href);
};

export const getListOfColumnsToExport = (
  configuration: { headerColumns?: string[] },
  defaultColumns: { name: string; valuePath?: string; caption?: string; hidden?: boolean; colId?: string }[],
  columnSpecifications?: { name: string; valuePath?: string; caption?: string }[],
): ColumnInput[] => {
  if (configuration?.headerColumns?.length) {
    return configuration.headerColumns.map((name) => {
      const spec = columnSpecifications?.find((c) => c.name === name);
      return {
        name: spec?.valuePath ?? name,
        displayName: spec?.caption ?? name,
      };
    });
  }

  return defaultColumns
    .filter((x) => !x.hidden)
    .map((x) => ({
      name: x.valuePath ?? x.name ?? x.colId ?? '',
      displayName: x.caption ?? x.name ?? x.colId ?? '',
    }));
};
